import ReassuranceButtons from './ReassuranceButtons.vue'

export default ReassuranceButtons
